export function appointmentStatus(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr + "T00:00:00");
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const days = Math.round((d - today) / 86400000);
  if (days < 0) return { label: `Overdue by ${-days} day${-days !== 1 ? "s" : ""}`, tone: "overdue", days };
  if (days === 0) return { label: "Due today", tone: "due", days };
  if (days <= 7) return { label: `In ${days} day${days !== 1 ? "s" : ""}`, tone: "soon", days };
  return { label: `In ${days} days`, tone: "ok", days };
}

export const toneClasses = {
  overdue: "bg-destructive/10 text-destructive border-destructive/30",
  due: "bg-destructive/10 text-destructive border-destructive/30",
  soon: "bg-yellow-50 text-yellow-800 border-yellow-300",
  ok: "bg-primary/10 text-primary border-primary/30",
};

export function formatDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr + "T00:00:00");
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
}
